<template>
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#016B00]">Newsletter Upload</h1>
        <p class="text-xs text-[#747474] mt-2">Home / Announcement / Newsletter</p>
    </div>
    <div class="papsi-container flex flex-col w-[100%] h-[70vh] gap-6 mt-7 ">
        <div class="papsi-container h-[300px]overflow-auto">
            <div class="flex items-center gap-5 mb-5">
                <h1 class="text-[#016B00] font-semibold text-lg">Search/Edit Newsletter Portal</h1>
                <button v-on:click="HideView" class="bg-[#016B00] w-[180px] text-xs font-semibold p-2 rounded-md text-white hover:bg-[#CCAF12] py-3">+ Add Newsletter</button>
            </div>
            <div v-if="TableView" class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
                <TableControl :Action="true" :header="header" :column="column" :info="info" :view="view" :VButton="true" :EButton="false" :DButton="true" @ViewButton="ViewButton" @EditButton="EditButton" @DeleteButton="DeleteButton"/>
            </div>
        </div>
    </div>
    <div v-if="EnabledAdd" >
        <div @click="EnabledAdd = false" class="w-full h-full fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
            <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
                <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#016B00] relative">
                    <div class="pafcpic_header bg-[#016B00] py-3 px-6">
                        <p class="text-[#ffffff] text-md font-semibold">ADD NEWSLETTER</p>
                    </div>
                    <div class="pafcpic_body py-6 px-6">
                        <select class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="quarter">
                            <option selected disabled value="">Select Quarter</option> 
                            <option value="1st Quarter">1st Quarter</option>
                            <option value="2nd Quarter">2nd Quarter</option>
                            <option value="3rd Quarter">3rd Quarter</option>
                            <option value="4th Quarter">4th Quarter</option>
                        </select>
                        <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Upload PDF Newsletter</p>
                        <input type="file" @change="onFileChange" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#afb1af] font-semibold w-full outline-none">
                    </div>
                    <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                        <button class="text-sm text-white bg-[#016B00] py-1.5 px-7 rounded-md w-[100px] text-center" @click="Addnewsletter">Add</button>
                        <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md w-[100px] text-center" v-on:click="EnabledAdd = false">Cancel</button>
                    </div>
                    </div>
            </div>
        </div>

        <ValidPrompt v-if="validationprompt" @yes="confirmedDelete" @cancel="cancelValidation" :header="promtHead" :header1="promtBody" />

    <div v-if="Delete">
        <Prompt type="DELETE" @close="Delete = false"/>
    </div>

    
    <div v-if="Success">
        <Prompt type="ADDNEWSLETTER" @close="Success = false"/>
    </div>

    <div v-if="Validation">
        <Prompt type="VALIDATION" @close="Validation = false"/>
    </div>
    
</template>


<script>

import { defineComponent } from 'vue';
import TableControl from '@/components/controls/TableControl/TableControl.vue'
import Prompt from './Prompt/RequestPromt.vue'
import Services from './../../services/admin'
import ValidPrompt from './Prompt/ValidationPrompt.vue'

export default defineComponent ({
    components:{
        TableControl,
        Prompt,
        ValidPrompt
    },
    data(){
        return{
            feed_code:null,
            promtHead:null,
            promtBody:null,
            validationprompt:false,
            type:'',
            Validation:false,
            Success:false,
            Delete:false,
            EnabledAdd: false,
            TableView: true,
            info: null,
            quarter: '',
            file:null,
            ViewTable: 'Add Newsletter',
            source:'',
            header:[
                    {
                        title:'Reference No.'
                    },
                    {
                        title:'Quarter'
                    },
                    {
                        title:'Date Published'
                    },
                    {	
                        title:'Action'
                    },
                    
                ],
                column:[
                    'feed_code',
                    'title',
                    'date'
                   
                ]
        }
    },
    mounted(){
        this.Getallnewsletter()
    },
    methods: {
         ViewButton(row){
            window.open(row.file_path, '_blank');
            
            // try {
            //     this.$emit("showLoader")
            //     const success = await Services.getNewsletterbyID(row.feed_code);
            //     this.source = success.data.source
            //     this.viewFile();

            //     this.$emit("hideLoader")
            // }
            // catch (error) {
            //     console.error("Error:", error);
            // }
        },
        cancelValidation(){
    
            this.validationprompt = false
        },
        viewFile(row){
            window.open(row.file_path, '_blank');

            // if (!this.source) {
            //     alert("No source data available.")
            //     return;
            // }
            // let pdfWindow = window.open("");
            // setTimeout(() => {
            //     pdfWindow.stop();
            //     pdfWindow.document.write(
            //         "<html style='margin:0 0 0 0; padding:0 0 0 0;'><title>Newsletter</title><iframe style='margin:0 0 0 0; padding:0 0 0 0; width: 100%; height: 100%; border: none; position: absolute; top:0; left:0;' src='data:application/pdf;base64, " +
            //         encodeURI(this.source) + "'></iframe></html>"
            //     );
            // }, 1000);
        },
        DeleteButton(row){
            this.feed_code = row.feed_code
            this.promtHead      = "DELETE NEWSLETTER"
            this.promtBody      = "Are you sure you want to delete this "+ row.title +" published on " + row.date;
            this.validationprompt = true
   
 
        },
        async confirmedDelete(){
            this.$emit("showLoader")
            this.validationprompt = false
            const success = await Services.deleteNewsletter(this.feed_code);
            this.test = success.data
            await this.Getallnewsletter()
            this.Delete = true
            this.$emit("hideLoader")
        },
        onFileChange(e){
            this.file = e.target.files[0];
        },
        async Addnewsletter(){
            this.$emit("showLoader")

            if(!this.file || !this.quarter){
                this.$emit("hideLoader")
                    this.Validation = true
                return
            }
            const success = await Services.addNewsletter(this.quarter,this.file);
            this.test = success.data

            this.EnabledAdd = false
            this.Getallnewsletter()
            this.Success = true
        },
        HideView(){
            if (!this.TableView){
                this.TableView = true
                this.EnabledAdd = false
                this.ViewTable = '+ Add Newsletter'
            }
            else{
                this.EnabledAdd = true
                this.ViewTable = 'View Table'
            }
        },
        async Getallnewsletter(){
            this.$emit("showLoader")
            const success = await Services.getNewsletter();
            this.info = success.data
            this.$emit("hideLoader")
        }
    },
    
})


</script>

